import React from "react";
import "./style.css";

// ==== Images ====
import apiImage from "./assets/integrations-banner.png"; // top banner image
import syncImage from "./assets/integrations-features-1.png"; // sync section image
import { FaFolder } from "react-icons/fa"; // for colorful folder icons

const APISection = () => {
  return (
    <>
      {/* ===== API Banner Section ===== */}
      <section className="api-banner">
        <div className="api-overlay">
          <p className="api-subtitle">API Documentation</p>
          <h1 className="api-title">
            Automate Your Workflows <br /> With Direct Integrations
          </h1>
          <p className="api-text">Close your books faster, with zero errors.</p>
        </div>
      </section>

      {/* ===== API Image Section ===== */}
      <section className="api-image-section">
        <div className="api-container">
          <img src={apiImage} alt="API Integration" className="api-img" />
        </div>
      </section>

      {/* ===== Sync With Your Favourite Software Section ===== */}
      <section className="sync-section">
        <div className="sync-container">
          {/* Left Text */}
          <div className="sync-content">
            <p className="sync-subtitle">Close the books in record time</p>
            <h1 className="sync-title">
              Sync With Your <br /> Favourite Software
            </h1>
            <p className="sync-text">
              Automate bookkeeping, reconciliation, and reporting with direct
              integrations to your existing accounting tools. Omeswara’s
              API-first approach helps you eliminate manual work, reduce errors,
              and maintain accurate financial records effortlessly.
            </p>
          </div>

          {/* Right Image */}
          <div className="sync-image">
            <img src={syncImage} alt="Sync Integration" />
          </div>
        </div>
      </section>

      {/* ===== Intelligent Categorisation Section ===== */}
      <section className="category-section">
        <div className="category-container">
          {/* Left Circular Rings + Folder Icons */}
          <div className="category-left">
            <div className="circle-wrapper">
              <div className="circle-ring ring1"></div>
              <div className="circle-ring ring2"></div>
              <div className="circle-ring ring3"></div>
              <div className="circle-ring ring4"></div>
              <div className="circle-ring ring5"></div>

              {/* Floating Folder Icons */}
              <div className="folder-icon folder1">
                <FaFolder color="#00B2FF" />
              </div>
              <div className="folder-icon folder2">
                <FaFolder color="#22D172" />
              </div>
              <div className="folder-icon folder3">
                <FaFolder color="#A259FF" />
              </div>
              <div className="folder-icon folder4">
                <FaFolder color="#FFC107" />
              </div>
              <div className="folder-icon folder5">
                <FaFolder color="#FF3366" />
              </div>
            </div>
          </div>

          {/* Right Text */}
          <div className="category-right">
            <h1 className="category-title">
              Intelligent <br /> categorisation that <br /> Cuts Your Work in
              Half
            </h1>
            <p className="category-text">
              Save valuable hours every month with Omeswara’s intelligent
              categorisation engine. Our platform automatically maps
              transactions to the correct ledger accounts, making reconciliation
              faster and significantly more accurate.
            </p>
          </div>
        </div>
      </section>

      {/* ===== Platform Integration Section ===== */}
      <section className="platform-section">
        <div className="platform-container">
          <p className="platform-subtitle">Platform Integration</p>
          <h1 className="platform-title">
            Integrate Plugins to Start Accepting <br /> Payments in Minutes
          </h1>
          <p className="platform-text">
            Omeswara offers smooth, ready-to-use plugins for popular
            platforms—allowing you to begin accepting payments quickly.
            Customize the setup to match your business needs, or use our
            plug-and-play modules for rapid deployment without complex coding.
          </p>
        </div>
      </section>
    </>
  );
};

export default APISection;
